import React, { lazy, Component, useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getProducts } from "../../redux/actions/productActions";
import {
  getCategories,
  getCategory,
} from "../../redux/actions/categoriesActions";
import { Link } from "react-router-dom";
import { data } from "../../data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTh, faBars } from "@fortawesome/free-solid-svg-icons";
import { SERVER_BASE_URL } from "../../config/config";
import AppPagination from "../../helpers/appPagination";
import { Helmet } from "react-helmet-async";
const Paging = lazy(() => import("../../components/Paging"));
const Breadcrumb = lazy(() => import("../../components/Breadcrumb"));
const FilterCategory = lazy(() => import("../../components/filter/Category"));
const FilterPrice = lazy(() => import("../../components/filter/Price"));
const FilterSize = lazy(() => import("../../components/filter/Size"));
const FilterStar = lazy(() => import("../../components/filter/Star"));
const FilterColor = lazy(() => import("../../components/filter/Color"));
const FilterTag = lazy(() => import("../../components/filter/Tag"));
const FilterClear = lazy(() => import("../../components/filter/Clear"));
const CardServices = lazy(() => import("../../components/card/CardServices"));
const CardProductGrid = lazy(() =>
  import("../../components/card/CardProductGrid")
);
const CardProductList = lazy(() =>
  import("../../components/card/CardProductList")
);

const YoutubeLinks = () => {
  const dispatch = useDispatch();

  const [view, setView] = useState("grid");
  const [links, setLinks] = useState();
  const [page, setPage] = useState(1);

  const token = useSelector(
    (state) => state?.userLogin?.user?.tokens?.access?.token
  );

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const getLinks = () => {
    axios
      .get(`${SERVER_BASE_URL}/v1/app/link?sortBy=updatedAt:desc`, config)
      .then((res) => setLinks(res.data.payload.results))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getLinks();
  }, []);

  const onChangeView = (e) => {
    if (e === "grid") {
      setView("grid");
    } else {
      setView("list");
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>
          {`Youtube Links |
            சந்தியா பதிப்பகம் |
            Sandhyapathippagam |
            Sandhyapublications`}
        </title>
        <link
          rel="canonical"
          href={`https://www.sandhyapublications.com/youtube-links`}
        />
      </Helmet>
      <div
        className="p-5 bg-primary bs-cover"
        style={
          {
            // backgroundImage: "url(../../images/banner/50-Banner.webp)",
          }
        }
      >
        <div className="container text-center">
          <span className="display-5 px-3 text-light">Youtube Links</span>
        </div>
      </div>
      {/* <Breadcrumb /> */}
      <div className="container-fluid mt-3 mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-8">
                <span className="align-middle font-weight-bold">
                  {/* {this.state.totalItems} results for{" "} */}
                  <span className="text-warning"></span>
                </span>
              </div>
            </div>
            <hr />
            <div className="row g-3">
              {console.log("links", links)}
              {links &&
                links?.map((link, idx) => {
                  return (
                    <div key={idx} className="col-md-6 mb-5">
                      <iframe width="100%" height="400" src={link?.link} />
                      <div className="text-center">
                        <a href={link?.link}>{link?.title}</a>
                      </div>
                    </div>
                  );
                })}
            </div>
            <hr />
            <AppPagination setPage={setPage} {...links} />
            {/* <Paging
                totalRecords={this.state.totalItems}
                pageLimit={9}
                pageNeighbours={3}
                onPageChanged={this.onPageChanged}
                sizing=""
                alignment="justify-content-center"
              /> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default YoutubeLinks;
